import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) => state?.homeState || initialState;

export const selectIsLoading = createSelector(
  [selectDomain],
  (homeState) => homeState.isLoading,
);

export const selectMyProjects = createSelector(
  [selectDomain],
  (homeState) => homeState.myProjects,
);

export const selectMyTickets = createSelector(
  [selectDomain],
  (homeState) => homeState.myTickets,
);

// My Tickets Section
export const selectIsTicketsLoading = createSelector(
  [selectDomain],
  (homeState) => homeState.isTicketsLoading,
);

export const selectMyTicketsList = createSelector(
  [selectDomain],
  (homeState) => homeState.myTicketsList,
);

export const selectTicketsPagination = createSelector(
  [selectDomain],
  (homeState) => homeState.ticketsPagination,
);

export const selectMyTicketsFilters = createSelector(
  [selectDomain],
  (homeState) => homeState.myTicketsFilters,
);

// Project Details
export const selectProjectDetails = createSelector(
  [selectDomain],
  (homeState) => homeState.projectDetails,
);

// User Activities
export const selectIsActivitiesLoading = createSelector(
  [selectDomain],
  (homeState) => homeState.isActivitiesLoading,
);

export const selectUserActivities = createSelector(
  [selectDomain],
  (homeState) => homeState.userActivities,
);

export const selectActivitiesPagination = createSelector(
  [selectDomain],
  (homeState) => homeState.activitiesPagination,
);

export const selectActivityFilters = createSelector(
  [selectDomain],
  (homeState) => homeState.activityFilters,
);
